var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1151 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745117 22.6384 0.745117 50.2484C0.745117 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74512 74.5084 6.74512 50.2484C6.74512 42.7784 8.61512 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9751 42.2484L74.2651 38.1384H67.3151L67.6051 42.2484H69.3951V57.8584C69.3951 58.2084 69.5351 58.5184 69.7651 58.7484C69.9951 58.9784 70.3151 59.1184 70.6551 59.1184C70.9951 59.1184 71.3251 58.9784 71.5451 58.7484C71.7751 58.5184 71.9151 58.2084 71.9151 57.8584V42.2484H73.9751Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4451 35.6184L75.5151 20.6684C75.7151 17.9284 73.5351 15.5884 70.7851 15.5884C68.0351 15.5884 65.8551 17.9284 66.0551 20.6684L67.1251 35.6184H74.4451Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8451 57.8584C73.8451 59.6084 72.4151 61.0284 70.6651 61.0284C68.9151 61.0284 67.4851 59.6084 67.4851 57.8584V48.8784L57.0051 56.9284L68.2051 83.2884C69.1251 85.4484 72.1951 85.4484 73.1151 83.2884L84.3151 56.9284L73.8351 48.8784V57.8584H73.8451Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3251 38.3684H42.4851V28.2884H22.3251V38.3684Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4051 15.5584H30.6151C26.1551 18.1484 22.2351 21.5884 19.0751 25.6384H32.4051V15.5584Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0651 15.5584V25.6384H55.2251V15.5584H35.0651Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6751 28.2884H17.1851C16.5251 29.2884 15.9051 30.3284 15.3351 31.3984C14.1451 33.6084 13.1751 35.9384 12.4251 38.3684H19.6751V28.2884Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5751 89.3084H42.4851V79.2284H23.0251C28.1151 84.0984 34.4851 87.6484 41.5751 89.3084Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4051 66.4984H14.0651C15.7051 70.1784 17.8851 73.5784 20.4951 76.5784H32.4051V66.4984Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0651 66.4984V76.5784H55.2251V66.4984H35.0651Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3251 53.7584V63.8384H42.4851V53.7584H22.3251Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6751 53.7584H10.7851C11.0851 57.2684 11.8451 60.6484 12.9951 63.8384H19.6751V53.7584Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4051 51.1084V41.0284H12.2451V51.1084H32.4051Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0651 41.0284V51.1084H55.2251V41.0284H35.0651Z",
    fill: "#FF9900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1685",
    x: -0.0000186563,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1685",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1685"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1685",
    result: "effect3_innerShadow_4857_1685"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralConstruction);
export default __webpack_public_path__ + "static/media/GeneralConstruction.e171dbb506ef2811a0e125b34cb2537a.svg";
export { ForwardRef as ReactComponent };